export const LOCATION_CHANGE = 'ROUTER/LOCATION_CHANGE';
export const LOCATION_REDUCER_NOT_FOUND = 'LOCATION_REDUCER_NOT_FOUND';
